import React from 'react';
import moment from 'moment-timezone';
/* eslint-disable react/prop-types */

const DateRange = ({ event }) => {
  const timeZone = event.get('timeZone');
  return (
    <span>
      {moment.tz(event.get('startOn'), timeZone).format('MMMM DD')} -{' '}
      {moment.tz(event.get('endOn'), timeZone).format('MMMM DD YYYY')}
    </span>
  );
};

export default DateRange;
